import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { environment } from 'src/environments/environment';
import { CommonService } from "../library/pcl_lib";
import { Globals } from "../global/global-variable";
import axios from "axios";
@Injectable({
    providedIn : "root"
})

export class BulkSearchService {
    constructor(private router: Router,
        private http: HttpClient,
        private global : Globals,
        private lib : CommonService){        
    }//end constructor

    public filterList(q): Observable<result_data>{
        const headers = new HttpHeaders({
            'Authorization' : 'Bearer '+localStorage.getItem('accessToken')
        });
        const requestOptions: Object = {
            responseType: 'json',
            headers : headers
        }//end
        return this.http.post(environment.get_data_staging,q,requestOptions);
    }


    public process_bulk_search(function_param): Observable<result_data>{
        const headers = new HttpHeaders({
            'Authorization' : environment.elastic_api_key
        });

        const requestOptions: Object = {
            responseType: 'json',
            headers : headers
        }//end
        
        
        return this.http.post(environment.process_bulk,function_param,requestOptions);
    }

    public process_bulk_search_wiki(function_param): Observable<result_data>{
        const headers = new HttpHeaders({
            'Authorization' : 'Bearer '+(localStorage.getItem('accessToken') ?? '')
        });

        const requestOptions: Object = {
            responseType: 'json',
            headers : headers
        }//end
        
        
        return this.http.post(environment.process_bulk_wiki,function_param,requestOptions);
    }

    public process_bulk_search_adverse(function_param): Observable<result_data>{
        const headers = new HttpHeaders({
            'Authorization' : 'Bearer '+(localStorage.getItem('accessToken') ?? '')
        });
        const requestOptions: Object = {
            responseType: 'json',
            headers : headers
        }//end
        return this.http.post(environment.process_bulk_adverse,function_param,requestOptions);
    }
}//end class

export interface result_data {}